import { render } from "./ImageVideo.vue?vue&type=template&id=cfd4c694"
import script from "./ImageVideo.vue?vue&type=script&lang=js"
export * from "./ImageVideo.vue?vue&type=script&lang=js"

import "./ImageVideo.vue?vue&type=style&index=0&id=cfd4c694&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__